<template>
  <div
    class="modal fade slide-down disable-scroll"
    :id="modal_id"
    tabindex="-1"
    role="dialog"
    aria-hidden="false"
    style="padding-right: 0px !important"
  >
    <div :class="'modal-dialog ' + modal_size">
      <div class="modal-content-wrapper rounded bg-white shade">
        <div class="modal-content bg-white shade">
          <div class="modal-header clearfix text-left m-b-20 pt-0">
            <div
              class="shade ml-auto clickable hoverable bg-white"
              style="
                margin-right: -30px;
                margin-top: -15px;
                height: 2rem;
                width: 2rem;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <i
                class="bi bi-x"
                style="font-size: 30px"
                data-dismiss="modal"
              ></i>
            </div>
            <h5 class="m-b-0">
              {{ data_modal.title }}
            </h5>
            <p class="p-b-0 m-b-0">
              {{ data_modal.subtitle }}
            </p>
          </div>
          <div class="modal-body">
            <component :is="data_modal.component" :data="data" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import default_content_modal from "@/views/components/default_content_modal.vue";
export default {
  name: "modal_dynamic",
  props: {
    modal: {
      type: Object,
      default: function () {
        return {
          title: "Title Here",
          subtitle: "Sub Title Here",
          component: default_content_modal,
        };
      },
    },
    modal_id: {
      type: String,
      default: function () {
        return "modalSlideUp";
      },
    },
    data: {},
    static: {
      type: Boolean,
      default: false,
    },
    modal_size: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data_modal: this.modal,
    };
  },
  mounted: function () {
    // console.log(this.data)
    let self = this;
    $("#" + this.modal_id).modal({
      backdrop: this.static ? "static" : true,
      show: true,
    });
    $("body").on("#" + self.modal_id + " hidden.bs.modal", function () {
      self.$emit("close");
    });
  },
};
</script>

<style scoped>
.modal {
  padding-right: 0px !important;
}
.modal-lg {
  max-width: 50% !important;
  width: 50% !important;
}

.modal-full {
  max-width: 100% !important;
  width: 100% !important;
}
</style>
